import React, {
  FunctionComponent,
  useContext,
  SyntheticEvent,
  useMemo,
} from 'react'
import styled from 'styled-components'
import encodeurl from 'encodeurl'
import Octicon, { X } from '@primer/octicons-react'
import Cookies from 'js-cookie'
import { SessionContext } from '~/components'

interface Props {
  orderCost?: number | null
  orderHeight?: number | null
  orderLength?: number | null
  orderWeight?: number | null
  orderWidth?: number | null
  pointId?: string | null
  dealerId?: string
  lat?: number | null
  lng?: number | null
  handleMapClose: (e: SyntheticEvent) => void
}

const Container = styled.div`
  height: 100%;
  top: 0;
  z-index: 55;
`

const Map: FunctionComponent<Props> = (props: Props) => {
  const { currentDealer } = useContext(SessionContext)
  const { 'next-i18next': locale } = Cookies.get()
  let { uuid } = currentDealer

  if (props.dealerId) {
    uuid = props.dealerId
  }

  const mapUrl = useMemo(() => {
    let query = ''
    Object.keys(props).map(prop => {
      if (prop === 'handleMapClose') return
      if (prop === 'dealerId') return
      query += '&' + prop + '=' + props[prop]
    })
    let chartUrl = process.env.NEXT_PUBLIC_WIDGETS_IFRAME_URL
    if (typeof window !== "undefined") {
        chartUrl = window.location.href
    }
    let url = `${process.env.NEXT_PUBLIC_WIDGETS_IFRAME_URL}/${process.env.NEXT_PUBLIC_VIA_MAPS_ENV}/`
    // let url = `http://localhost:3000/${process.env.NEXT_PUBLIC_VIA_MAPS_ENV}/`
        url += `?lang=${locale}&dealerId=${uuid}&action=true&zoom=10&${query}`
        url += `&forwardedFor=${chartUrl}`
        url = encodeurl(url)
    return url
  }, [])
  return (
    <Container className="w-full overflow-hidden absolute bottom-0 left-0 z-40 bg-white">
      <div className="w-full flex justify-end">
        <button
          className="px-2 py-1 m-1 text-gray-700 hover:text-gray-800"
          onClick={props.handleMapClose}
        >
          <Octicon icon={X} className="text-gray-800" />
        </button>
      </div>

      <iframe
        src={mapUrl}
        frameBorder="0"
        width="100%"
        height="96%"
        className="rounded"
      ></iframe>
    </Container>
  )
}

export default Map
